/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseBlogRelatedArticlesFragment, BlogRelatedArticlesFragment, FullBlogRelatedArticlesFragment} from '@amblique/contentful/app/contentful/fragments/blog-related-articles';

/**
 * Get a single BlogRelatedArticles by ID (base - scalars only)
 */
export const getBaseBlogRelatedArticlesById = gql`
  ${BaseBlogRelatedArticlesFragment}

  query GetBaseBlogRelatedArticlesById($id: String!, $locale: String!, $preview: Boolean) {
    blogRelatedArticles(id: $id, locale: $locale, preview: $preview) {
      ...BaseBlogRelatedArticlesFragment
    }
  }
`;

/**
 * Get a single BlogRelatedArticles by ID (standard - 1 level deep)
 */
export const getBlogRelatedArticlesById = gql`
  ${BlogRelatedArticlesFragment}

  query GetBlogRelatedArticlesById($id: String!, $locale: String!, $preview: Boolean) {
    blogRelatedArticles(id: $id, locale: $locale, preview: $preview) {
      ...BlogRelatedArticlesFragment
    }
  }
`;

/**
 * Get a single BlogRelatedArticles by ID (full - 2 levels deep)
 */
export const getFullBlogRelatedArticlesById = gql`
  ${FullBlogRelatedArticlesFragment}

  query GetFullBlogRelatedArticlesById($id: String!, $locale: String!, $preview: Boolean) {
    blogRelatedArticles(id: $id, locale: $locale, preview: $preview) {
      ...FullBlogRelatedArticlesFragment
    }
  }
`;

/**
 * Get all BlogRelatedArticles entries with pagination (base - scalars only)
 */
export const getBaseBlogRelatedArticless = gql`
  ${BaseBlogRelatedArticlesFragment}

  query GetBaseBlogRelatedArticless(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BlogRelatedArticlesOrder]
    $where: BlogRelatedArticlesFilter
    $preview: Boolean
  ) {
    blogRelatedArticlesCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseBlogRelatedArticlesFragment
      }
    }
  }
`;

/**
 * Get all BlogRelatedArticles entries with pagination (standard - 1 level deep)
 */
export const getBlogRelatedArticless = gql`
  ${BlogRelatedArticlesFragment}

  query GetBlogRelatedArticless(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BlogRelatedArticlesOrder]
    $where: BlogRelatedArticlesFilter
    $preview: Boolean
  ) {
    blogRelatedArticlesCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BlogRelatedArticlesFragment
      }
    }
  }
`;

/**
 * Get all BlogRelatedArticles entries with pagination (full - 2 levels deep)
 */
export const getFullBlogRelatedArticless = gql`
  ${FullBlogRelatedArticlesFragment}

  query GetFullBlogRelatedArticless(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BlogRelatedArticlesOrder]
    $where: BlogRelatedArticlesFilter
    $preview: Boolean
  ) {
    blogRelatedArticlesCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullBlogRelatedArticlesFragment
      }
    }
  }
`;
